<div class=" layout-topbar shadow-md">

<div class=" layout-topbar-logo-container">
		@if (
			hydration.hydrated() && keycloakService.authenticated && !layoutService.showLanding()
		) {
			<button (click)="layoutService.onMenuToggle()" class="layout-menu-button layout-topbar-action">
				<i class="pi pi-bars"></i>
			</button>
		}
<!--		<a [routerLink]="keycloakService.authenticated ? null : 'trader/portfolio'" class="layout-topbar-logo">-->
<!--			<img src="assets/images/TADA.png" alt="tadaLogo" style="width: 10rem" />-->
<!--			<span class="text-white">{{ 'app.title' | translate }}</span>-->
<!--			<p class="text-xs text-white">{{ 'app.description' | translate }}</p>-->
<!--		</a>-->
		<span (click)="goToLanding()"
			class="flex items-center gap-2 md:gap-3 group cursor-pointer">
			<img src="beautyLogo.png" alt="logo" class="h-10 md:h-12" />

			<img src="beautyTypoghrafy.png" alt="" class="h-7 md:h-12" />
		</span>
<!--		<div class="hidden lg:flex gap-4">-->
<!--			<a routerLink="/" class="color- hover:underline">{{ 'mainPage' | translate }}</a>-->
<!--			<a (click)="moveToTadaPage('about-us')" class="hover:underline">{{ 'aboutUs.title' | translate }}</a>-->
<!--			<a (click)="moveToTadaPage('contact-us')" class="hover:underline">{{ 'contactUs.title' | translate }}</a>-->
<!--		</div>-->
	</div>

	<div class="flex justify-center ml-20">

		<nav class="hidden lg:flex items-center text-base gap-1 l-16 ">
			<a
				routerLink="/pro-ads"
				class="px-4 py-2 rounded-lg text-white font-bold blink-bg transition-all">
				آگهی‌های ویژه
			</a>
			<a class="px-4 py-2 rounded-lg   text-gray-700
			  hover:bg-gray-200 transition-all"
				 routerLink="/search" data-discover="true">جستجوی آگهی‌ها</a>
<!--			<a class="px-4 py-2 rounded-lg   text-gray-700 hover:bg-gray-200 transition-all"-->
<!--				 routerLink="/auctions" data-discover="true">مزایده</a>-->
<!--			<a class="px-4 py-2 rounded-lg   text-gray-700-->
<!--				  hover:bg-gray-200 transition-all" routerLink="/partner" data-discover="true">همراه شو</a>-->
			<a class="px-4 py-2 rounded-lg   text-gray-700 hover:bg-gray-200 transition-all"
				 routerLink="/brand-advertising" data-discover="true">تبلیغات برندها</a>
		</nav>
	</div>

	<div class="layout-topbar-actions">
<!--		@if (keycloakService.authenticated) {-->
<!--			<div class="md:flex hidden gap-2">-->
<!--				<span>{{ today | convertDateToJalali: 'YEAR_MONTH_DAYSTR' }}</span>-->
<!--			</div>-->

<!--			<div [ngClass]="connectionStateCssClass()" class="connection-status-icon items-center">-->
<!--				@switch (connectionState()) {-->
<!--					@case (SocketClientState.CONNECTED) {-->
<!--						<i-->
<!--							class="pi pi-check-circle text-green-500"-->
<!--							pTooltip="{{ 'CONNECTION.CONNECTED' | translate }}"-->
<!--							tooltipPosition="left"></i>-->
<!--					}-->
<!--					@case (SocketClientState.ATTEMPTING) {-->
<!--						<i-->
<!--							class="pi pi-spin pi-spinner text-yellow-500"-->
<!--							pTooltip="{{ 'CONNECTION.ATTEMPTING' | translate }}"-->
<!--							tooltipPosition="left"></i>-->
<!--					}-->
<!--					@case (SocketClientState.DISCONNECTED) {-->
<!--						<i-->
<!--							class="pi pi-ban text-red-500"-->
<!--							pTooltip="{{ 'CONNECTION.DISCONNECTED' | translate }}"-->
<!--							tooltipPosition="left"></i>-->
<!--					}-->
<!--				}-->
<!--			</div>-->
<!--		}-->

		<div class="layout-config-menu">
			<div class="flex gap-8">
				<a
					pTooltip="جستجو"
					[routerLink]="['/search']"
					class="text-gray-700 text-xl cursor-pointer duration-200
           hover:text-gray-400  active:scale-90"
				>
					<i class="pi pi-search"></i>
				</a>
							@if (hydration.hydrated() && keycloakService.authenticated){
				@if (layoutService.showLanding()) {
					<button
						pTooltip="پنل کاربری"
						(click)="goToPanel()"
						class="text-gray-700 text-xl cursor-pointer duration-200
           hover:text-gray-400  active:scale-90">
						<i class="pi pi-th-large"></i>
					</button>

			} @else {
				<button
					(click)="goToLanding()"
					pTooltip="صفحه اصلی"
					class="text-gray-700 text-xl cursor-pointer duration-200
            hover:text-gray-400  active:scale-90">
					<i class="pi pi-home"></i>
				</button>
			}
							}

			</div>
<!--			<button (click)="toggleDarkMode()" type="button" class="flex cursor-pointer">-->
<!--				<i-->
<!--					[ngClass]="{-->
<!--						pi: true,-->
<!--						'pi-moon': layoutService.isDarkTheme(),-->
<!--						'pi-sun': !layoutService.isDarkTheme(),-->
<!--					}"></i>-->
<!--			</button>-->
			<!--			..................................... COLOR PALETTE ................................................-->
			<!--			<div class="relative">-->
			<!--				<button-->
			<!--					class="layout-topbar-action layout-topbar-action-highlight"-->
			<!--					pStyleClass="@next"-->
			<!--					enterFromClass="hidden"-->
			<!--					enterActiveClass="animate-scalein"-->
			<!--					leaveToClass="hidden"-->
			<!--					leaveActiveClass="animate-fadeout"-->
			<!--					[hideOnOutsideClick]="true"-->
			<!--				>-->
			<!--					<i class="pi pi-palette"></i>-->
			<!--				</button>-->
			<!--				<div class="absolute">-->
			<!--					<app-configurator />-->
			<!--				</div>-->
			<!--			</div>-->
		</div>
<!--		<div class="hidden items-center gap-2 md:flex">-->
<!--			<p-splitbutton [model]="items()" [label]="selectedLangItem()?.label" severity="secondary"></p-splitbutton>-->
<!--		</div>-->
		<a (click)="menuOpen.set(false)" routerLink="/pro-ads" class="lg:hidden px-4 py-2 rounded-lg text-sm font-bold text-white blink-bg transition-all text-center shadow-md hover:shadow-lg active:scale-95">
			آگهی ویژه
		</a>
		<button
			[hideOnOutsideClick]="true"
			(click)="toggleMenu($event)"
			#menuBtn
			class="layout-topbar-menu-button layout-topbar-action"
			pStyleClass="@next"
			enterFromClass="hidden"
			enterActiveClass="animate-scalein"
			leaveToClass="hidden"
			leaveActiveClass="animate-fadeout">
			<i class="pi pi-ellipsis-v"></i>
		</button>
		<div class="flex items-center mx-2">

<!--			@if (keycloakService.authenticated) {-->
<!--				@if ((profileImageFileId() | fileLink | async)?.url; as avatarUrl) {-->
<!--					<img [src]="avatarUrl" alt="avatar" class="mx-2 h-9 w-9 rounded-full object-cover" />-->
<!--				} @else if (firstName()) {-->
<!--					<div-->
<!--						class="mx-2 flex h-9 w-9 items-center justify-center rounded-full bg-surface-300 text-sm font-bold text-surface-700">-->
<!--						{{ firstName().charAt(0) }}-->
<!--					</div>-->
<!--				}-->
<!--			}-->

			@if (hydration.hydrated() && keycloakService.authenticated) {
				<p-button (click)="logout()" size="large">
					<a>{{ 'landing.logout' | translate }}</a>
				</p-button>
			} @else {
				<p-button (click)="login()" size="large">
					<a>{{ 'landing.login' | translate }}</a>
				</p-button>
			}
		</div>


		<div [class.hidden]="!menuOpen()" #menu class="layout-topbar-menu">
			<div class="layout-topbar-menu-content">
<!--				<button class="layout-topbar-action">-->
<!--					<i class="pi pi-inbox"></i>-->
<!--					<a (click)="menuOpen.set(false)" routerLink="/" class="color- hover:underline">{{-->
<!--						'mainPage' | translate-->
<!--					}}</a>-->
<!--				</button>-->
<!--				<button class="layout-topbar-action">-->
<!--					<i class="pi pi-inbox"></i>-->
<!--					<a (click)="menuOpen.set(false)" routerLink="/about-us" class="hover:underline">{{-->
<!--						'aboutUs.title' | translate-->
<!--					}}</a>-->
<!--				</button>-->
<!--				<button class="layout-topbar-action">-->
<!--					<i class="pi pi-inbox"></i>-->
<!--					<a (click)="menuOpen.set(false)" routerLink="/contact-us" class="hover:underline">{{-->
<!--						'contactUs.title' | translate-->
<!--					}}</a>-->
<!--				</button>-->
				<div class="flex flex-col gap-2 justify-evenly items-center">
					<!-- سرچ -->
					<button
						(click)="menuOpen.set(false)"
						[routerLink]="['/search']"
						class=" px-4 py-2 rounded-lg text-sm font-bold bg-gray-200  transition-all flex items-center gap-2"
					>
						<i class="pi pi-search"></i>
						جستجو
					</button>

				<hr class="w-full border-t border-gray-300 my-2">

				<a (click)="menuOpen.set(false)" routerLink="/pro-ads" class="blink-bg px-4 py-2 rounded-lg text-sm font-bold text-white transition-all w-full text-center">
					آگهی‌های ویژه
				</a>

				<a (click)="menuOpen.set(false)" routerLink="/search" data-discover="true" class="px-4 py-2 rounded-lg text-sm text-gray-700 hover:bg-gray-100 hover:shadow-sm hover:scale-[1.02] active:scale-95 transition-all w-full text-center">
					جستجوی آگهی‌ها (اجاره فضا / دوره / تجهیزات)
				</a>
<!--				<a (click)="menuOpen.set(false)" routerLink="/auctions" data-discover="true" class="px-4 py-2 rounded-lg text-sm text-gray-700 hover:bg-gray-100 hover:shadow-sm hover:scale-[1.02] active:scale-95 transition-all w-full text-center">-->
<!--					مزایده-->
<!--				</a>-->
<!--				<a (click)="menuOpen.set(false)" routerLink="/partner" data-discover="true" class="px-4 py-2 rounded-lg text-sm text-gray-700 hover:bg-gray-100 hover:shadow-sm hover:scale-[1.02] active:scale-95 transition-all w-full text-center">-->
<!--					همراه شو-->
<!--				</a>-->
				<a (click)="menuOpen.set(false)" routerLink="/brand-advertising" data-discover="true" class="px-4 py-2 rounded-lg text-sm text-gray-700 hover:bg-gray-100 hover:shadow-sm hover:scale-[1.02] active:scale-95 transition-all w-full text-center">
					تبلیغات برندها
				</a>
				</div>
			</div>
		</div>

	</div>
</div>
